import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../css/Header.css';

const PhoneIcon = ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
);

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    // Bloque le défilement de la page et ferme avec Échap tant que le menu mobile est ouvert
    useEffect(() => {
        if (!menuOpen) return undefined;
        const onKeyDown = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [menuOpen]);

    return (
        <header className="header">
            <div className="header-content">
                <NavLink to="/" className="header-logo" onClick={closeMenu}>
                    <img src="/img/home/logo-blanc.png" alt="" className="header-logo-img" width="50" height="50" />
                    <span className="header-company-name">
                        <span className="company-main">CC Débarras</span>
                        <span className="company-department">14</span>
                    </span>
                </NavLink>

                <div className="header-actions">
                    <button
                        type="button"
                        className={`hamburger-menu ${menuOpen ? 'active' : ''}`}
                        aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
                        aria-expanded={menuOpen}
                        aria-controls="header-menu"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>

                <div id="header-menu" className={`header-links ${menuOpen ? 'active' : ''}`}>
                    <nav aria-label="Navigation principale">
                        <ul>
                            <li><NavLink to="/" onClick={closeMenu}>Accueil</NavLink></li>
                            <li><NavLink to="/avant-apres" onClick={closeMenu}>Avant/Après</NavLink></li>
                            <li><NavLink to="/nos-trouvailles" onClick={closeMenu}>Nos trouvailles</NavLink></li>
                            <li><NavLink to="/nos-avis" onClick={closeMenu}>Nos avis</NavLink></li>
                            <li><NavLink to="/laisser-un-avis" onClick={closeMenu}>Laisser un avis</NavLink></li>
                            <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>
                        </ul>
                    </nav>

                    <div className="header-menu-contact">
                        <a href="tel:0767567254" className="header-menu-call">
                            <PhoneIcon size={19} />
                            Appeler le 07 67 56 72 54
                        </a>
                        <div className="header-menu-socials">
                            <a href="mailto:ccdebarras14@gmail.com" aria-label="Nous écrire un email">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                            </a>
                            <a href="https://www.instagram.com/cc_debarras/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect width="20" height="20" x="2" y="2" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r=".5" fill="currentColor" /></svg>
                            </a>
                            <a href="https://www.facebook.com/GAUTHERIE" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`header-backdrop ${menuOpen ? 'active' : ''}`} onClick={closeMenu} aria-hidden="true"></div>
        </header>
    );
};

export default Header;
